module.exports = __webpack_public_path__ + "img/1493986321.df3cefe3.jpg";